export default __webpack_public_path__ + "static/media/tyre_change.7b6728a8.svg";